import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { CellClassRules, ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-enterprise';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { ReportService } from '../..';
import 'ag-grid-enterprise';

@Component({
    selector: 'app-occupancy-summary-report',
    templateUrl: './occupancy-summary-report.component.html',
    styleUrls: ['./occupancy-summary-report.component.css'],
    standalone: false
})
export class OccupancySummaryReportComponent implements OnInit, AfterViewInit {

	@Input() showSearchUI = true;
	@Input() resRevByDay: any = [];

	constructor(
		public messageService: MessageService,
		public reportService: ReportService) { }

	gridApi: GridApi;
	columnApi: ColumnApi;

	// ag-grid columns
	occupancyNtsCellClassRule: CellClassRules = this.reportService.occupancyNtsCellClassRule;
	occupancyPctCellClassRule: CellClassRules = this.reportService.occupancyPctCellClassRule;


	autoGroupColumnDef = {
		headerName: 'Property',
		cellRendererParams: {
			suppressCount: true,
			// checkbox: true,
		}
	};

	defaultColDef: ColDef = {
		sortable: true,
		filter: true,
	};

	// 10-2-22 removed pinned: 'left' in propertyCode field.  would not compile after upgrade to v28
	columnDefs = [
		{ headerName: 'Property', field: 'propertyCode', rowGroup: true, hide: false,  lockPinned: true},
		{
			headerName: 'Months', field: 'monthName', pivot: true, pivotComparator: (valueA, valueB) => {
				const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
					'August', 'September', 'October', 'November', 'December'];
				// sorts 'months' in chronological order
				return months.indexOf(valueA) - months.indexOf(valueB);
			},
		},
		{ headerName: 'Occ Nts %', cellClassRules: this.occupancyPctCellClassRule, valueGetter: this.getRentedPercent, cellRenderer: this.percentCellRenderer, aggFunc: 'sum' },
		{ headerName: 'Rate TTL', field: 'revRoomRateNetPNT', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
		{ headerName: 'Occ Nts #', field: 'numNightsTTL', volatile: true, aggFunc: 'sum', },



		/*		{
					headerName: 'Property', field: 'propertyCode', rowGroup: true, hide: true
				},
				{
					headerName: 'Year', field: 'year', rowGroup: true, hide: true, valueGetter: this.getYearFromDate
				},
				{
					headerName: 'Month', field: 'date', rowGroup: true, hide: true, valueGetter: this.getMonthFromDate
				},
				{ headerName: 'ReservationId', field: 'reservationId', rowGroup: true, hide: true, valueGetter: this.getGuestName },
				{ headerName: 'Occ Nts #', field: 'numNightsTTL', cellClassRules: this.cellClassRules, aggFunc: 'sum' },
				{ headerName: 'Occ Nts %', valueGetter: this.getRentedPercent, cellClassRules: this.cellClassRules, cellRenderer: this.percentCellRenderer, aggFunc: 'sum' },
				{ headerName: 'Occ Nts Guest', field: 'numNtsGuestTTL', aggFunc: 'sum' },
				{ headerName: 'Rate PNT', field: 'revRoomRateNetPNT', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'avgAggFunction' },
				{ headerName: 'Rate TTL', field: 'revRoomRateNetPNT', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
				{ headerName: 'Comm TTL', field: 'revCommissionPNT', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
				{ headerName: 'Resort TTL', field: 'revResortPNT', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
				{ headerName: 'Dmg TTL', field: 'revDamageWaiverPNT', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
				{ headerName: 'Hskp TTL', field: 'revHousekeepingPNT', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },*/


	];


	gridOptions: GridOptions = {
		// GLOBAL PROPERTIES
		// Objects like myRowData and myColDefs would be created in your application
	}


	// forms
	formLoading = false;


	// to hold the current search
	currentSearchForm: any;


	// data
	resRevMaster: any[];
	resRevMasterByDay: any[];
	resRev: any[];
	resRevTotal: any[];
	resRevTotalByDay: any[];
	resRevTotalByMonth: any[];
	resRevTotalByYear: any[];


	// search defaults
	defaultStartDate: Date
	defaultEndDate: Date
	defaultReservationStatuses: any;
	defaultShortTermRentalIds: any;

	getRentedPercent(params: any) {
		return (params.data.numNightsTTL / params.data.numNtsInMonthTTL)
	}


	getNtsAvailToRent(params: any) {
		let ntsAvailToRent = new Date(moment(params.data.date).year(), moment(params.data.date).month(), 0).getDate() - (params.data.numNtsOwnerTTL + params.data.numNtsOwnerGuestTTL + params.data.numNtsMaintTTL);
		console.log('ntsAvailToRent' + ntsAvailToRent);
		return ntsAvailToRent;
	}

	getDaysInMonth(month: number, year: number) {
		console.log('days ' + new Date(year, month, 0).getDate());
		return new Date(year, month, 0).getDate();
	}


	getYearFromDate(params: any) {
		return moment(params.data.date).format('YYYY')
	}

	getMonthFromDate(params: any) {
		return moment(params.data.date).format('MMM');
	}

	getGuestName(params: any) {
		return params.data.reservationId + ' ' + params.data.guestLastName;
	}

	currencyCellRendererUSD(params: any) {
		let inrFormat = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		});
		return inrFormat.format(params.value);
	}

	percentCellRenderer(params: any) {
		let inrFormat = new Intl.NumberFormat('en-US', {
			style: 'percent',
			minimumFractionDigits: 1,
			maximumFractionDigits: 1
		});
		return inrFormat.format(params.value);
	}

	ngOnInit(): void {
		this.defaultStartDate = new Date();
		// this.defaultStartDate = new Date(this.defaultStartDate.getFullYear()-4, this.defaultStartDate.getMonth(), 1);
		this.defaultStartDate = new Date(this.defaultStartDate.getFullYear(), 0, 1); // jan 1
		this.defaultEndDate = new Date();
		this.defaultEndDate = new Date(this.defaultEndDate.getFullYear(), 12, 0);

		this.defaultReservationStatuses = ['OP', 'OO', 'OG', 'NA'];
		this.defaultShortTermRentalIds = [1];

		// ag-grid
		this.gridOptions.rowData = this.resRevByDay;
		this.gridOptions.columnDefs = this.columnDefs;
		this.gridOptions.autoGroupColumnDef = this.autoGroupColumnDef;
		this.gridOptions.pagination = false;
		this.gridOptions.suppressAggFuncInHeader = true;
		this.gridOptions.pivotMode = true;
		this.gridOptions.animateRows = true;
		this.gridOptions.defaultColDef = this.defaultColDef;
		// this.gridOptions.pivotColumnGroupTotals= 'before';
		this.gridOptions.pivotRowTotals = 'before';
		this.gridOptions.groupIncludeFooter = true;
		this.gridOptions.groupIncludeTotalFooter = true;



		// https://www.ag-grid.com/javascript-data-grid/column-sizing/
		// this.gridOptions.suppressColumnVirtualisation = true;
	}

	onSearchSubmit(searchForm: any) {
		this.currentSearchForm = searchForm;
		this.runReservationRevenueReport(searchForm);
	}

	onRowGroupOpened(event) {
		this.columnApi.autoSizeAllColumns();
	}
	
	runReservationRevenueReport(searchForm) {
		try {
			this.formLoading = true;
			searchForm.reservationStatusList = this.reportService.revanueReservations;
			this.reportService.reservationRevenueReport(searchForm)
				.subscribe(
					res => {
						console.log('runReservationRevenueReport SUCCESS: ' + JSON.stringify(res));
						this.resRevByDay = res.data.resRevenues.resRevByDay;
						this.columnApi.autoSizeAllColumns();
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 3000 });
					},
					err => {
						console.log('runReservationRevenueReport FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: runReservationRevenueReport' });
		}
	}

	ngAfterViewInit(): void {
		this.gridOptions.animateRows = true;
		(this.gridOptions as any).api?.setColumnDefs(this.columnDefs);
	}

	onGridReady(grid: any): void {
		this.gridApi = grid;
		this.columnApi = grid.columnApi;

	}
	onFirstDataRendered(params: any): void {
		setTimeout(() => { this.columnApi.autoSizeAllColumns(); }, 2000);

	}
}
